import { useQuery } from 'react-query';

import {
  type GetCardProductRegulatoryLimitsInput,
  getCardProductRegulatoryLimits,
} from 'modules/cards/api/getCardProductRegulatoryLimits';

export const useGetCardProductRegulatoryLimits = ({
  cardProduct,
  companyId,
}: GetCardProductRegulatoryLimitsInput) => {
  return useQuery(['cardProductRegulatoryLimits', companyId, cardProduct], () =>
    getCardProductRegulatoryLimits({
      cardProduct,
      companyId,
    }),
  );
};
